import { render, staticRenderFns } from "./VSvg.vue?vue&type=template&id=372393b9"
import script from "./VSvg.vue?vue&type=script&lang=ts"
export * from "./VSvg.vue?vue&type=script&lang=ts"
import style0 from "./VSvg.vue?vue&type=style&index=0&id=372393b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports